module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo-container"
  }, [_c('svg', {
    staticClass: "logo",
    attrs: {
      "viewBox": '-2 -2 ' + (_vm.w + 4) + ' ' + (_vm.h + 4),
      "width": (_vm.w + 4),
      "height": (_vm.h + 4),
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('defs', [_c('filter', {
    attrs: {
      "id": "dropshadow"
    }
  }, [_c('feGaussianBlur', {
    attrs: {
      "in": "SourceAlpha",
      "stdDeviation": "2"
    }
  }), _vm._v(" "), _c('feOffset', {
    attrs: {
      "dx": "2",
      "dy": "2",
      "result": "offsetblur"
    }
  }), _vm._v(" "), _c('feMerge', [_c('feMergeNode'), _vm._v(" "), _c('feMergeNode', {
    attrs: {
      "in": "SourceGraphic"
    }
  })], 1)], 1)]), _vm._v(" "), _c('g', [_c('g', {
    attrs: {
      "filter": "url(#dropshadow)",
      "transform": 'translate(' + _vm.xArrow + ', ' + _vm.yArrow + ') rotate(' + _vm.rArrow + ', 123, 94)'
    }
  }, [_c('path', {
    attrs: {
      "d": 'M0,' + (_vm.h * 0.385) + ' L' + (_vm.w - _vm.h * 0.14) + ',' + (_vm.h * 0.015) + ' A' + (_vm.h * 0.04) + ',' + (_vm.h * 0.04) + ' 0 0 1 ' + (_vm.w - _vm.h * 0.1) + ',' + (_vm.h * 0.015) + ' L' + (_vm.w - _vm.h * 0.02) + ',' + (_vm.h * 0.12) + ' A' + (_vm.h * 0.04) + ',' + (_vm.h * 0.04) + ' 0 0 1 ' + (_vm.w - _vm.h * 0.02) + ',' + (_vm.h * 0.17) + ' L0,' + (_vm.h * 0.615) + ' Z',
      "fill": _vm.colors[1]
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "filter": "url(#dropshadow)",
      "transform": 'translate(' + _vm.xBar + ', ' + _vm.yBar + ') rotate(' + _vm.rBar + ', 15, 85)'
    }
  }, [_c('rect', {
    attrs: {
      "x": _vm.h * 0.02,
      "y": _vm.h * 0.01,
      "width": _vm.h * 0.18,
      "height": _vm.h * 0.98,
      "rx": _vm.h * 0.04,
      "ry": _vm.h * 0.04,
      "fill": "#607d8b"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "filter": "url(#dropshadow)",
      "transform": 'translate(' + _vm.xArrow + ', ' + _vm.yArrow + ') rotate(' + _vm.rArrow + ', 123, 94)'
    }
  }, [_c('path', {
    attrs: {
      "d": 'M0,' + (_vm.h * 0.385) + ' L' + (_vm.w - _vm.h * 0.02) + ',' + (_vm.h * 0.84) + ' A' + (_vm.h * 0.04) + ',' + (_vm.h * 0.04) + ' 0 0 1 ' + (_vm.w - _vm.h * 0.02) + ',' + (_vm.h * 0.89) + ' L' + (_vm.w - _vm.h * 0.1) + ',' + (_vm.h * 0.985) + ' A' + (_vm.h * 0.04) + ',' + (_vm.h * 0.04) + ' 0 0 1 ' + (_vm.w - _vm.h * 0.14) + ',' + (_vm.h * 0.985) + ' L0,' + (_vm.h * 0.615) + ' Z',
      "fill": _vm.colors[0]
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b774e48"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Logo.vue
// module id = 69
// module chunks = 0